import { create } from "zustand";
import { AnswerResponse } from "../api-objects/Answer";
import { Answer } from "../api-objects/survey-completed";

interface SurveyDataState {
    healthAssessmentQuestions: string[] | null;
    checkupSurveyQuestions: string[] | null;
    keyQuestions: string[] | null;
    healthAssessmentCompleted: boolean | null;
    healthAssessmentAnswers: Answer[] | null;
    allAnswers: AnswerResponse[] | null;
}

interface SurveyDataStore {
    surveyData: SurveyDataState;
    updateSurveyData: (updates: Partial<SurveyDataState>) => void;
    clearSurveyData: () => void;
}

// Zustand store
export const useSurveyDataStore = create<SurveyDataStore>((set) => ({

    // Initialize from localStorage
    surveyData: JSON.parse(localStorage.getItem("surveyData") || "{}") as SurveyDataState || {
        healthAssessmentQuestions: null,
        checkupSurveyQuestions: null,
        keyQuestions: null,
        healthAssessmentCompleted: null,
        healthAssessmentAnswers: null,
        allAnswers: null,
    },

    updateSurveyData: (updates) => {
        set((state) => {
            const updatedSurveyData = { ...state.surveyData, ...updates };
            localStorage.setItem("surveyData", JSON.stringify(updatedSurveyData));
            return { surveyData: updatedSurveyData };
        });
    },

    clearSurveyData: () => {
        const clearedSurveyData: SurveyDataState = {
            healthAssessmentQuestions: null,
            checkupSurveyQuestions: null,
            keyQuestions: null,
            healthAssessmentCompleted: null,
            healthAssessmentAnswers: null,
            allAnswers: null,
        };
        set({ surveyData: clearedSurveyData });
        localStorage.removeItem("surveyData");
    },
}));